import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { USER_ACCOUNT_ACTIONS, UserAccountActions } from '@/app/platform/platform-data/actions/types';
import { USER_ACCOUNT_QUERIES, UserAccountQueries } from '@/app/platform/platform-data/queries/types';

@Component({
    selector: 'user-select',
    templateUrl: './user-select.component.html',
    styleUrls: ['./user-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserSelectComponent extends FieldType implements OnInit{

  constructor(
    @Inject(USER_ACCOUNT_ACTIONS)
    private readonly userActions: UserAccountActions,
    @Inject(USER_ACCOUNT_QUERIES)
     readonly userQueries: UserAccountQueries) {
    super();
  }

  ngOnInit(): void {
    this.userActions.loadAll();
  }
}
